import { render, staticRenderFns } from "./BottomMenuSelection.vue?vue&type=template&id=74439228&scoped=true"
import script from "./BottomMenuSelection.vue?vue&type=script&lang=js"
export * from "./BottomMenuSelection.vue?vue&type=script&lang=js"
import style0 from "./BottomMenuSelection.vue?vue&type=style&index=0&id=74439228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74439228",
  null
  
)

export default component.exports